import type {
	CustomItem,
	DropAnchorType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropTabBarEnd = (
	item: Item | CustomItem
): item is DropAnchorType => {
	return !!(item && item.__typename === 'Drop_Tab_Bar_End');
};
